module.exports = __webpack_public_path__ + "ce6e94cc4454fef1d85dd3d0d1eb0de7.jpg";